import { Component, inject, input } from '@angular/core'
import { Router } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

import { DeviceService, Navigation } from '@ti/core/common/services'
import { AiChatBoldIconComponent } from '@ti/core/icons/ai-support/ai-chat-bold-icon.component'
import { AiChatMaximizeIconComponent } from '@ti/core/icons/ai-support/ai-chat-maximize-icon.component'
import { AiChatMinimizeIconComponent } from '@ti/core/icons/ai-support/ai-chat-minimize-icon.component'
import { AiChatOutlineIconComponent } from '@ti/core/icons/ai-support/ai-chat-outline-icon.component'
import { TooltipDirective } from '@ti/core/ui-kit/layout/directives'
import { SidebarService } from '@ti/core/ui-kit/layout/services'

import { AssistantChatFacade } from '../../services/assistant-chat.facade'

@Component({
  selector: 'app-assistant-menu-button',
  templateUrl: 'menu-button.component.html',
  styleUrls: ['menu-button.component.scss'],
  imports: [
    AiChatBoldIconComponent,
    AiChatMaximizeIconComponent,
    AiChatMinimizeIconComponent,
    AiChatOutlineIconComponent,
    TooltipDirective,
    TranslatePipe,
  ],
})
export class AssistantMenuButtonComponent {
  public readonly isCollapsed = input(false)

  protected readonly device = inject(DeviceService)
  protected readonly router = inject(Router)
  protected readonly navigation = inject(Navigation)
  protected readonly assistant = inject(AssistantChatFacade)
  protected readonly sidebarService = inject(SidebarService)

  protected onClicked(e: MouseEvent) {
    e.preventDefault()
    e.stopPropagation()

    if (this.device.isMobile()) {
      return this.assistant.openFullscreen()
    }

    this.openDialogMode()
  }

  protected openDialogMode() {
    if (this.assistant.state.isFullscreenMode()) {
      return
    }

    if (this.device.isMobile()) {
      this.sidebarService.hide()
    }

    return this.assistant.openDialog()
  }
}
